// extracted by mini-css-extract-plugin
export var bodySections = "_cz-8";
export var gray = "_cz-7";
export var green = "_cz-4";
export var iconContainer = "_cz-9";
export var iconWidgetContainer = "_cz-1";
export var phoneIcon = "_cz-2";
export var red = "_cz-5";
export var statusDot = "_cz-3";
export var widgetContainer = "_cz-0";
export var yellow = "_cz-6";